module.exports = __webpack_public_path__ + "static/media/ios-bowtie.6bf750bb.svg";